import type { ReactElement } from "react";

import ContactSalesLink from "./ContactSalesLink.js";
import { formatCupsAndTbsp } from "./volumeHelpers.js";

/**
 * Displays the pretty version of a fill amount
 *
 * @param props The component props.
 * @param props.ml The millileter fill amount.
 * @returns The component.
 */
export function FillAmount(props: { ml: number | undefined }): ReactElement {
	const { ml } = props;
	if (!ml) {
		return <ContactSalesLink />;
	}
	return (
		<div className="dl:flex dl:flex-col">
			<span>{ml} ml</span>
			<span>{formatCupsAndTbsp(ml)}</span>
		</div>
	);
}
